export function titleToSlug(title) {
  // Convert title to lowercase and replace all non-alphanumeric characters with dashes
  const slug = title.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-');

  // Remove any leading or trailing dashes
  return slug.replace(/^-+|-+$/g, '');
}
